import { useRoute } from "@react-navigation/core";
import { useNavigation } from "@react-navigation/native";
import React from "react";
import { StyleSheet, View } from "react-native";
import LeaderReferLink from "@components/Profile/LeaderReferLink";
import CompleteClProfile from "@screens/Home/CompleteClProfile";
import SettingsCard from "@screens/Home/SettingsCard";
import StoryBanner from "@screens/Home/StoryBanner";
import BannerListHorizontal, {
  BannerListHorizontalItem,
} from "@screens/LeaderTraining/BannerListHorizontal";
import { VideoListingItem } from "@screens/LeaderTraining/TrainingVideoListing";
import AddOffersOnWA from "./AddOffersOnWA";
import Banner, { VideoBanner } from "./Banner";
import BannerCarousel from "./BannerCarousel";
import BannerHeader from "./BannerHeader";
import BannersList from "./BannersList";
import Categories from "./Categories";
import ContactSyncBanner from "./ContactSyncBanner";
import DeliveryBanner from "./DeliveryBanner";
import DeliveryTimeline from "./DeliveryTimeline";
import GroupBuy from "./GroupBuy";
import InfiniteFlatList from "./InfiniteFlatList";
import LeaderAgentContact from "./LeaderAgentContact";
import ListShareItem from "./ListShareItem";
import NxMBanner from "./NxMBanner";
import NxMBannerContainer from "./NxMBannerContainer";
import ProductList from "./ProductList";
import SelfOrderBanner from "./SelfOrderBanner";
import SelfOrderBannerOnly from "./SelfOrderBannerOnly";
import ShopShareBanner from "./ShopShareBanner";
import SubPage from "./SubPage";
import WhatsappMsgBanner from "./WhatsappMsgBanner";
import WebCMS from "./WebCMS";
import NonInventoryProductList from "../NonInventoryProductList";

const rootScreens = ["Home", "PlaceOrderSuccess", "Gullak", "ConfirmOrder"];
const RenderCMSEntity = (dirtyProps) => {
  let { data } = dirtyProps;
  const { type, isRoot: dirtyIsRoot } = dirtyProps;
  data = data || {};

  const route = useRoute();
  const navigation = useNavigation();

  const props = { ...data, ...dirtyProps, navigation };
  const { allow_fullscreen = true } = props;
  const isRoot = rootScreens.includes(route.name) || dirtyIsRoot;

  let CMSComponent = null;
  let needProps = true;

  switch (type) {
    case "LIST_SHARE_ITEM":
      CMSComponent = ListShareItem;
      needProps = true;
      break;
    case "WEB_ENTITY":
      CMSComponent = WebCMS;
      needProps = true;
      break;
    case "BANNER_CAROUSEL":
      CMSComponent = BannerCarousel;
      needProps = true;
      break;
    case "SKU_LIST":
      CMSComponent = !isRoot ? InfiniteFlatList : ProductList;
      needProps = true;
      break;
    case "BANNER_LIST":
      CMSComponent = BannersList;
      needProps = true;
      break;
    case "BANNER":
      needProps = true;
      if (props.fromNxM) {
        CMSComponent = NxMBanner;
        break;
      } else if (
        !allow_fullscreen &&
        !props.fromBannerListHorizontal &&
        !props.fromTrainingVideoListing
      ) {
        CMSComponent = VideoBanner;
        break;
      } else if (props.fromBannerListHorizontal) {
        if (props.sub_type === "whatsapp_msg_banner") {
          CMSComponent = WhatsappMsgBanner;
          break;
        }
        CMSComponent = BannerListHorizontalItem;
        break;
      } else if (props.fromTrainingVideoListing) {
        CMSComponent = VideoListingItem;
        break;
      } else if (props.sub_type === "header_banner") {
        CMSComponent = BannerHeader;
        break;
      } else if (props.sub_type === "whatsapp_msg_banner") {
        CMSComponent = WhatsappMsgBanner;
        break;
      } else {
        CMSComponent = Banner;
        break;
      }

    case "CATEGORIES":
      CMSComponent = Categories;
      needProps = true;
      break;
    case "PAGE":
      CMSComponent = SubPage;
      needProps = true;
      break;
    case "GROUP_BUY":
      CMSComponent = GroupBuy;
      needProps = true;
      break;
    case "REFER_CARD":
      needProps = false;
      // eslint-disable-next-line react/no-unstable-nested-components
      CMSComponent = () => (
        <View style={styles.referCard}>
          <LeaderReferLink />
        </View>
      );
      break;
    case "ADD_OFFERS_ON_WA":
      CMSComponent = AddOffersOnWA;
      needProps = false;
      break;
    case "BANNER_LIST_HORIZONTAL":
      CMSComponent = BannerListHorizontal;
      needProps = true;
      break;
    case "NxM_GRID":
      needProps = true;
      CMSComponent = NxMBannerContainer;
      break;
    case "DELIVERY_TIMELINE":
      needProps = true;
      CMSComponent = DeliveryTimeline;
      break;
    case "DELIVERY_BANNER":
      needProps = true;
      CMSComponent = DeliveryBanner;
      break;
    case "SELF_ORDER_BANNER":
      CMSComponent = SelfOrderBanner;
      needProps = true;
      break;
    case "SELF_ORDER_BANNER_ONLY":
      CMSComponent = SelfOrderBannerOnly;
      needProps = true;
      break;
    case "AGENT_CONTACT_CARD":
      CMSComponent = LeaderAgentContact;
      needProps = true;
      break;
    case "CMS_STORIES":
      CMSComponent = StoryBanner;
      needProps = true;
      break;
    case "CONTACT_SYNC_CARD":
      CMSComponent = ContactSyncBanner;
      needProps = true;
      break;
    case "SHOP_SHARE":
      CMSComponent = ShopShareBanner;
      needProps = true;
      break;
    case "CL_FILL_PROFILE_CARD":
      CMSComponent = CompleteClProfile;
      needProps = true;
      break;
    case "GENERAL_SETTINGS_CARD":
      CMSComponent = SettingsCard;
      needProps = true;
      break;
    case "CL_NON_INVENTORY_SKU_LIST":
      CMSComponent = NonInventoryProductList;
      needProps = true;
      break;
    default:
      return null;
  }

  const entityProps = needProps ? props : {};
  return <CMSComponent {...entityProps} />;
};

const styles = StyleSheet.create({
  referCard: { paddingTop: 4, paddingHorizontal: 15 },
});

export default RenderCMSEntity;
